let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fiSRo")).then(() => parcelRequire('5AWOx'));